<header class="commercial-dialog__header">
  <div>
    <h2>Visibilità commerciale</h2>
    @if (acceptanceStatus === 'accepted') {
      <span class="commercial-dialog__status commercial-dialog__status--accepted">
        <mat-icon>check</mat-icon>{{ acceptedStatusLabel }}
      </span>
    } @else {
      <span class="commercial-dialog__status">Consenso non ancora accettato</span>
    }
  </div>
  <button mat-icon-button type="button" aria-label="Chiudi" (click)="close()" [disabled]="isSubmitting">
    <mat-icon>close</mat-icon>
  </button>
</header>

<mat-dialog-content class="commercial-dialog__content">
  <section class="commercial-dialog__notice">
    <mat-icon>error_outline</mat-icon>
    <p>
      Consentendo la visibilità commerciale, i tuoi dati di contatto potranno essere condivisi con la rete commerciale di SOA Consult per proposte relative ad altri servizi.
    </p>
  </section>

  <div class="commercial-dialog__copy">
    <p>SOA Consult potrà utilizzare i dati di contatto forniti per comunicazioni e proposte commerciali relative a servizi complementari alla qualificazione.</p>
    <p>Il consenso è facoltativo e non influisce sull’erogazione dei servizi già richiesti. I dati saranno trattati nel rispetto dell’informativa privacy e non saranno ceduti a soggetti terzi per finalità diverse da quelle indicate.</p>
    <p>Puoi modificare la tua scelta in qualsiasi momento: la revoca interrompe le future comunicazioni commerciali.</p>
  </div>
</mat-dialog-content>

<div class="commercial-dialog__consent">
  <mat-checkbox [(ngModel)]="agreed" [disabled]="acceptanceStatus === 'accepted' || isSubmitting">
    @if (acceptanceStatus === 'accepted') {
      Hai accettato questa informativa — la revoca è possibile in qualsiasi momento
    } @else {
      Ho letto l’informativa e acconsento alla visibilità commerciale
    }
  </mat-checkbox>
</div>

<mat-dialog-actions class="commercial-dialog__actions">
  <button mat-stroked-button type="button" (click)="close()" [disabled]="isSubmitting">Chiudi</button>
  @if (acceptanceStatus === 'accepted') {
    <button mat-flat-button color="primary" type="button" class="commercial-dialog__revoke" (click)="revoke()" [disabled]="isSubmitting || !canRevoke">
      <mat-icon>close</mat-icon>Revoca consenso
    </button>
  } @else {
    <button mat-flat-button type="button" color="primary" (click)="confirm()" [disabled]="!agreed || isSubmitting">
      <mat-icon>check</mat-icon>Accetta consenso
    </button>
  }
</mat-dialog-actions>
